/**
 * Thin, muted scrollbar for both themes.
 * Returns a CssBaseline-compatible style object keyed by mode.
 */
export default function scrollbar(mode) {
  const isDark = mode === "dark";

  const thumbColor = isDark ? "rgba(255, 255, 255, 0.18)" : "rgba(0, 0, 0, 0.18)";
  const thumbHover = isDark ? "rgba(255, 255, 255, 0.30)" : "rgba(0, 0, 0, 0.30)";

  return {
    "*::-webkit-scrollbar": {
      width: "6px",
      height: "6px",
    },
    "*::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "*::-webkit-scrollbar-thumb": {
      background: thumbColor,
      borderRadius: "3px",
      transition: "background 0.2s ease",
    },
    "*::-webkit-scrollbar-thumb:hover": {
      background: thumbHover,
    },
    "*::-webkit-scrollbar-corner": {
      background: "transparent",
    },
    // Firefox
    "*": {
      scrollbarWidth: "thin",
      scrollbarColor: `${thumbColor} transparent`,
    },
  };
}
